import * as i18next from "i18next";

export const getAmountInstructionText = (
  minPayableAmount: number | null | undefined,
  maxPayableAmount: number | null | undefined,
  t: i18next.TFunction,
) => {
  const hasMinPayableAmount =
    minPayableAmount !== null && minPayableAmount !== undefined;
  const hasMaxPayableAmount =
    maxPayableAmount !== null && maxPayableAmount !== undefined;

  if (hasMinPayableAmount && hasMaxPayableAmount) {
    if (minPayableAmount === maxPayableAmount) {
      return t("amount-instruction-equal", { min: minPayableAmount });
    }

    return t("amount-instruction-range", {
      min: minPayableAmount,
      max: maxPayableAmount,
    });
  }

  if (hasMinPayableAmount) {
    return t("amount-instruction-min", { min: minPayableAmount });
  }

  if (hasMaxPayableAmount) {
    return t("amount-instruction-max", { max: maxPayableAmount });
  }

  return t("amount-instruction-generic");
};
